// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130804/js/" + chunkId + "." + {"44":"3acff9a8","225":"e8918e91","481":"d1df0b9a","486":"622dd192","770":"09d7c1df"}[chunkId] + ".0.569243978128794.chunk.js";
};